import React, { useState } from "react";
import { useParams } from "react-router";
import LenderUgroService from "../../../../services/lender";
import Table from "../../../../components/Common/Table";
import TableNoRecords from "../../../../components/Common/Table/TableNoRecords";
import message from "../../../../constant/message";
import { toast } from "react-toastify";
import { Context } from "../../../../config/store";
import AudittrailStatusModal from "./StatusModal";
import AuditActions from "./AuditActions";
import './style.css'
import { objectsForEach } from "../../../../common/objectToArray";
import MasterDataService from "../../../../services/master-data";
export default function AuditTrail({ selectedLender }) {
  const [modalState, setModalState] = useState(false);
  const [statusData, setStatusData] = useState([])
  const { state, dispatch } = React.useContext(Context);
  const [lenderList, setLenderList] = useState([])
  const [alllender,setAllLender] = useState(selectedLender)
  const leadId = useParams().id;

  const columns = [
    { title: "Status", field: "activity_desc" },
    { title: "Remarks", field: "comment" },
    { title: "", field: "file_id", component: AuditActions },
    // { title: 'Browser Info', field: 'browser_info' },
    // {
    //   title: "Lead Type",
    //   field: "lead_type",
    //   component: ({ row }) => (
    //     <>
    //       {" "}
    //       {row.lead_type == 1 && "Pre Approved"}
    //       {row.lead_type == 2 && "Post Approved"}
    //       {row.lead_type == 3 && "Pre and then Post Approved"}
    //     </>
    //   ),
    // },
    { title: "Created by", field: "organization" },
    { title: "Created at", field: "created_at" },
  ];
  const [tableData, setTableData] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const getAuditTrailList = async () => {
    setLoading(true);
    try {
      const response = await LenderUgroService.getLeadAuditTrail(
        leadId,
        alllender ? alllender : lenderList?.[0]?.value,
        "cl_lead"
      );
      const data = response.data.data?.activity_logs;
      const newData = data.map((value) => {
        value.activity_desc = value.activity_desc;
        return value;
      });
      setTableData(newData);
      setStatusData(response.data.data.cl_lead.lender_assigned)
      setLoading(false);
    } catch (err) {
      setLoading(false);
      let error = err?.response?.newData?.messages?.error;
      toast.error(error?.form?.[0] || error?.others?.[0]);
    }
  };

  React.useEffect(() => {
    if(selectedLender || alllender || lenderList.length > 0){
      getAuditTrailList();
    }else{
      setLoading(false);
    }
  }, [selectedLender,alllender,lenderList]);

  React.useEffect(() => {
    auditTrailLender()
    setAllLender(selectedLender)
  }, [selectedLender]);

  const toggleModal = () => {
    setModalState(!modalState);
  };

  const auditTrailLender = async () => {
    try {
      let response = await MasterDataService.getAuditTrailLender(
        'admin',
        'co-lender',
        leadId
      )
      if (response?.data?.status?.code === 1) {
        let responseList = objectsForEach(
          response.data.data.lender_list,
          'STRING_VAL'
        );
        let lenderItems = responseList.map((response) => ({
          label: response.value,
          value: response.id,
        }));
        setLenderList(lenderItems)
      }
    } catch (error) {

    }
  }
  return (
    <>
      <div className='row no-gutters justify-content-between align-items-center mt-2'>
        <div></div>
        <div className='mb-2'>
          {/* <button className='btn btn-custom' onClick={toggleModal}>
            Check Status
          </button>
          {modalState && (
            <AudittrailStatusModal
              userType={state.userType}
              state={modalState}
              toggleModal={toggleModal}
              leadId={leadId}
              lenderId={selectedLender}
              statusData={statusData}
            />
          )} */}
       { lenderList.length > 0 && <select className="form-control" onChange={(e)=>setAllLender(e.target.value)} value={alllender}>
            {lenderList?.map (({value,label})=>{
              return <option value={value}>{label}</option>
            })}
          </select>}
        </div>
      </div>
      <div className="auditTrail">
      <Table
        checkbox={false}
        columns={columns}
        rows={tableData}
        loading={loading}
        tableExtraClass={""}
        reloadTable={getAuditTrailList}
      >
        {Boolean(!tableData.length && !loading) && <TableNoRecords />}
      </Table>
      </div>
      {/* queryInfo.cl_lender_id  &&*/}
    </>
  );
}
